import { FC, useEffect, useState } from "react";
import { useUsersStore } from "../../hooks";
import avatar1 from "images/avatars/Image-1.png";
import MyReservation from "../../containers/MyReservationPage/MyReservation";
import {
  Search,
  Pencil,
  Trash2,
  Eye,
  X,
  AlertTriangle,
  ChevronLeft,
  ChevronRight,
  UsersRound,
} from "lucide-react";

// eslint-disable-next-line
const registerFormFields = {
  uid: "",
  name: "",
  phone: "",
  email: "",
  address: "",
  rol: "",
  dateBirth: "",
};

const inputClass =
  "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-white placeholder-slate-500 transition focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/30";

const UserList: FC<any> = () => {
  const [isOpen, setIsOpen] = useState(false);
  // eslint-disable-next-line
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const { deleteUser, getUsers, updateUser, users } = useUsersStore();
  const [isOpenDelet, setIsOpenDelet] = useState(false);
  const [openUserReservations, setOpenUserReservations] = useState(false);
  const [search, setSearch] = useState("");
  // eslint-disable-next-line
  const [dataUserQuantity, setDataUserQuantity] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  const [formValues, setFormValues] = useState({
    uid: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    rol: "",
    dateBirth: "",
  });
  const onInputChanged = ({ target }: any) => {
    setFormValues({ ...formValues, [target.name]: target.value });
  };
  const abrirModal = (user: any) => {
    setFormValues({
      uid: user._id,
      name: user.name,
      phone: user.phone,
      email: user.email,
      address: user.address,
      rol: user.rol,
      dateBirth: user.dateBirth,
    });
    setIsOpen(true);
  };

  const cerrarModal = () => {
    setSelectedUser("");
    setIsOpen(false);
  };

  const modalDelete = (user: any) => {
    setFormValues({
      uid: user._id,
      name: user.name,
      phone: user.phone,
      email: user.email,
      address: user.address,
      rol: user.rol,
      dateBirth: user.dateBirth,
    });
    setIsOpenDelet(true);
  };

  const closeModalDelete = () => {
    setIsOpenDelet(false);
  };

  const modalReservations = (user: any) => {
    setFormValues({
      uid: user._id,
      name: user.name,
      phone: user.phone,
      email: user.email,
      address: user.address,
      rol: user.rol,
      dateBirth: user.dateBirth,
    });
    setSelectedUser(user._id);
    setOpenUserReservations(true);
  };

  const closeModalReservations = () => {
    setFormValues({ uid: "", name: "", phone: "", email: "", address: "", rol: "", dateBirth: "" });
    setOpenUserReservations(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (openUserReservations && !event.target.closest(".modal-content")) {
        closeModalReservations();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openUserReservations]);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const { uid, name, phone, email, address, rol, dateBirth } = formValues;
    try {
      updateUser(uid, name, phone, email, address, rol, dateBirth);
      cerrarModal();
    } catch (error) {
      console.error("Error al actualizar el usuario:", name);
    }
    cerrarModal();
  };

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (isOpen && !event.target.closest(".modal-content")) {
        cerrarModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  useEffect(() => {
    const handleEscKey = (event: any) => {
      if (isOpen && event.keyCode === 27) {
        cerrarModal();
      }
    };
    document.addEventListener("keydown", handleEscKey);
    return () => document.removeEventListener("keydown", handleEscKey);
  }, [isOpen]);

  const handleDelete = (event: any) => {
    event.preventDefault();
    const userId = formValues.uid;
    try {
      deleteUser(userId);
      closeModalDelete();
    } catch (error) {
      console.error("Error al eliminar el usuario:", error);
    }
  };

  const searcher = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const finishIndex = currentPage * dataUserQuantity;
  const startIndex = finishIndex - dataUserQuantity;

  let results = [];
  if (!search) {
    results = users.slice(startIndex, finishIndex);
  } else {
    results = users.filter(
      (user: any) =>
        user.name.toLowerCase().includes(search.toLocaleLowerCase()) ||
        user.phone.toLowerCase().includes(search.toLocaleLowerCase()) ||
        user.email.toLowerCase().includes(search.toLocaleLowerCase())
    );
  }

  let totalUser = users.length;
  const totalPages = Math.ceil(totalUser / dataUserQuantity);

  const nextPage = () => {
    if (currentPage !== totalPages) setCurrentPage(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage !== 1) setCurrentPage(currentPage - 1);
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
    } else if (currentPage <= 3) {
      pageNumbers.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
    }
    return pageNumbers;
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0c0a16] px-4 pb-8 pt-16 text-white sm:px-6 md:p-8">
      {/* glow de fondo */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 right-1/4 h-96 w-96 rounded-full bg-violet-600/15 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-screen-2xl">
        {/* Header */}
        <div className="mb-6 flex flex-col gap-4 rounded-2xl border border-white/10 bg-white/[0.04] p-5 shadow-xl backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-xl bg-violet-500/15 text-violet-300">
              <UsersRound size={20} />
            </span>
            <div>
              <h1 className="text-xl font-bold text-white">Usuarios</h1>
              <p className="text-sm text-slate-400">
                Total: <span className="font-semibold text-slate-200">{users.length}</span>
              </p>
            </div>
          </div>
          <div className="relative w-full sm:w-80">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <input
              value={search}
              onChange={searcher}
              placeholder="Buscar por nombre, email o teléfono"
              className={`${inputClass} pl-9`}
              aria-label="Buscar usuarios"
            />
          </div>
        </div>

        {/* Tabla (scroll horizontal en móvil) */}
        <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/[0.04] shadow-xl backdrop-blur-xl">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-white/10">
              <thead className="bg-white/[0.03]">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-400">Usuario</th>
                  <th className="px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-400">Teléfono</th>
                  <th className="hidden px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-400 lg:table-cell">Email</th>
                  <th className="px-6 py-3 text-right text-xs font-semibold uppercase tracking-wider text-slate-400">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {results.map((user: any) => (
                  <tr key={user._id} className="transition hover:bg-white/[0.04]">
                    <td className="whitespace-nowrap px-6 py-4">
                      <div className="flex items-center gap-3">
                        <img className="h-10 w-10 rounded-full border border-white/10 object-cover" src={user.image || avatar1} alt={user.name} />
                        <span className="text-sm font-semibold text-white">{user.name}</span>
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-sm text-slate-300">{user.phone}</td>
                    <td className="hidden whitespace-nowrap px-6 py-4 text-sm text-slate-300 lg:table-cell">{user.email}</td>
                    <td className="whitespace-nowrap px-6 py-4">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => abrirModal(user)}
                          aria-label={`Editar ${user.name}`}
                          className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 bg-white/5 text-indigo-300 transition hover:bg-indigo-500/20 hover:text-indigo-200"
                        >
                          <Pencil size={16} />
                        </button>
                        <button
                          onClick={() => modalDelete(user)}
                          aria-label={`Eliminar ${user.name}`}
                          className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 bg-white/5 text-rose-300 transition hover:bg-rose-500/20 hover:text-rose-200"
                        >
                          <Trash2 size={16} />
                        </button>
                        <button
                          onClick={() => modalReservations(user)}
                          aria-label={`Ver reservas de ${user.name}`}
                          className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 bg-white/5 text-emerald-300 transition hover:bg-emerald-500/20 hover:text-emerald-200"
                        >
                          <Eye size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr>
                    <td colSpan={4} className="px-6 py-10 text-center text-slate-400">
                      No se encontraron usuarios.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Paginación */}
        <div className="mt-6 flex flex-col items-center gap-3">
          <span className="text-xs font-semibold uppercase tracking-wider text-slate-400">
            Página {currentPage} / {totalPages || 1}
          </span>
          <nav aria-label="Pagination" className="flex w-full items-center justify-between">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 transition hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-30"
            >
              <ChevronLeft size={16} /> Anterior
            </button>
            <div className="flex items-center">
              {getPageNumbers().map((page, index) =>
                typeof page === "number" ? (
                  <button
                    key={index}
                    onClick={() => setCurrentPage(page)}
                    className={`mx-1 inline-flex h-9 w-9 items-center justify-center rounded-lg text-sm font-semibold transition ${
                      currentPage === page ? "bg-violet-500 text-white shadow-lg shadow-violet-500/30" : "text-slate-300 hover:bg-white/10"
                    }`}
                  >
                    {page}
                  </button>
                ) : (
                  <span key={index} className="mx-1 px-2 text-slate-500">
                    ...
                  </span>
                )
              )}
            </div>
            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className="inline-flex items-center gap-1 rounded-lg border border-white/10 bg-white/5 px-4 py-2 text-sm font-medium text-slate-200 transition hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-30"
            >
              Siguiente <ChevronRight size={16} />
            </button>
          </nav>
        </div>
      </div>

      {/* Modal Eliminar */}
      {isOpenDelet && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
          <div className="modal-content w-full max-w-sm rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 shadow-2xl backdrop-blur-xl">
            <div className="mb-2 flex justify-end">
              <button onClick={closeModalDelete} aria-label="Cerrar" className="grid h-8 w-8 place-items-center rounded-lg text-slate-400 transition hover:bg-white/10 hover:text-white">
                <X size={18} />
              </button>
            </div>
            <div className="flex flex-col items-center text-center">
              <span className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-rose-500/15 text-rose-300">
                <AlertTriangle size={26} />
              </span>
              <p className="text-slate-300">¿Deseas eliminar al usuario?</p>
              <p className="mt-2 text-xl font-bold text-white">{formValues.name}</p>
              <div className="mt-6 flex w-full gap-3">
                <button onClick={closeModalDelete} className="flex-1 rounded-lg border border-white/10 bg-white/5 px-4 py-2 font-medium text-slate-200 transition hover:bg-white/10">
                  Cancelar
                </button>
                <button onClick={handleDelete} className="flex flex-1 items-center justify-center gap-2 rounded-lg bg-rose-600 px-4 py-2 font-semibold text-white transition hover:bg-rose-700">
                  <Trash2 size={16} /> Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/70 p-4 backdrop-blur-sm">
          <div className="modal-content my-8 w-full max-w-md rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 shadow-2xl backdrop-blur-xl">
            <div className="mb-5 flex items-center justify-between">
              <h2 className="flex items-center gap-2 text-lg font-bold text-white">
                <Pencil size={18} className="text-indigo-300" /> Editar usuario
              </h2>
              <button onClick={cerrarModal} aria-label="Cerrar" className="grid h-8 w-8 place-items-center rounded-lg text-slate-400 transition hover:bg-white/10 hover:text-white">
                <X size={18} />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="nombre" className="mb-1 block text-sm font-medium text-slate-300">Nombre</label>
                <input type="text" id="nombre" name="name" value={formValues.name} onChange={onInputChanged} className={inputClass} required />
              </div>
              <div>
                <label htmlFor="telefono" className="mb-1 block text-sm font-medium text-slate-300">Teléfono</label>
                <input type="tel" id="telefono" name="phone" value={formValues.phone} onChange={onInputChanged} className={inputClass} />
              </div>
              <div>
                <label htmlFor="email" className="mb-1 block text-sm font-medium text-slate-300">Email</label>
                <input type="email" id="email" name="email" value={formValues.email} onChange={onInputChanged} className={inputClass} required />
              </div>
              <div>
                <label htmlFor="address" className="mb-1 block text-sm font-medium text-slate-300">Dirección</label>
                <input type="text" id="address" name="address" value={formValues.address} onChange={onInputChanged} className={inputClass} />
              </div>
              <div>
                <label htmlFor="dateBirth" className="mb-1 block text-sm font-medium text-slate-300">Fecha de nacimiento</label>
                <input type="text" id="dateBirth" name="dateBirth" value={formValues.dateBirth} onChange={onInputChanged} className={inputClass} />
              </div>
              <div>
                <label htmlFor="rol" className="mb-1 block text-sm font-medium text-slate-300">Rol</label>
                <select name="rol" id="rol" className={inputClass} value={formValues.rol} onChange={onInputChanged}>
                  <option value="admin">admin</option>
                  <option value="center">center</option>
                  <option value="user">user</option>
                </select>
              </div>
              <button type="submit" className="w-full rounded-lg bg-violet-500 px-4 py-2.5 font-semibold text-white shadow-lg shadow-violet-500/30 transition hover:bg-violet-600">
                Guardar cambios
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Modal Reservas del usuario */}
      {openUserReservations && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black/70 p-4 backdrop-blur-sm">
          <div className="modal-content relative my-8 w-full max-w-3xl rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 shadow-2xl backdrop-blur-xl">
            <button onClick={closeModalReservations} aria-label="Cerrar" className="absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-lg text-slate-400 transition hover:bg-white/10 hover:text-white">
              <X size={20} />
            </button>
            <MyReservation userId={formValues.uid} />
          </div>
        </div>
      )}
    </div>
  );
};
export default UserList;
